module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_10_100.93d09ba9.png";